const facet = document.querySelector(".product-facet");

async function fetchData(url) {
    const response = await fetch(url);
    const data = await response.json();
    return data;
}

function buildCustomSwatches(target, data) {
    if (!data.Swatches) return;

    data.Swatches.forEach((element, index) => {
        const type = element.info?.type?.trim();
        const swatchLabel = target?.querySelector(`[data-swatch="${type}"] label`);

        if (!swatchLabel || !type) {
            const colorSwatch = target?.querySelectorAll('.color-swatch')[index];
            if (colorSwatch) {
                colorSwatch.style.display = "none";
            }
            return;
        }
        swatchLabel.style.background = element.image ? `url(${element.image})` : element.info.colour;
    });
}

function observeProductIntersections() {
    document.querySelectorAll(".product-item").forEach(product => {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(async entry => {
                if (entry.isIntersecting || entry.intersectionRatio > 0) {
                    try {
                        const productHandle = product.dataset.handle;
                        const base = productHandle.split('?')[0];
                        const param = productHandle.match(/view=data$/);
                        const cleanedUrl = param ? `${base}?${param[0]}` : base;
                        const productId = product.dataset.id;
                        const url = `https://${window.themeVariables.routes.host}` + cleanedUrl + "?view=data";
                        const data = await fetchData(url);
                        const target = document.querySelector(`.product-item-meta__swatch-list[data-id="${productId}"]`);
                        if (target) {
                            target.style.opacity = 1;
                            buildCustomSwatches(target, data);
                        }
                    } catch (error) {
                        console.log(error);
                    }
                    observer.unobserve(entry.target);
                }
            });
        });

        observer.observe(product);
    });
}

window.addEventListener("DOMContentLoaded", (event) => {
    // colour swatches
    observeProductIntersections();

    document.addEventListener("theme:loading:end", () => setTimeout(observeProductIntersections, 2000));

    facet && facet.addEventListener("facet:criteria-changed", (e) => setTimeout(observeProductIntersections, 3000));

})